import { Drawer } from "@base-ui/react"
import { RiCloseLargeLine } from "@remixicon/react"
import { observer } from "mobx-react-lite"
import { useRef } from "react"
import { FLYING_CARPET_PAGES } from "./flying-carpet.pages"
import { FlyingCarpetPage, flyingCarpetStore } from "./flying-carpet.store"
import { cn } from "@utils/tw"

export const FlyingCarpet = observer(() => {
  const isOpen = flyingCarpetStore.isOpen
  const currentPage = flyingCarpetStore.currentPage

  const lastPage = useRef<FlyingCarpetPage | null>(currentPage)

  if (currentPage !== null) {
    lastPage.current = currentPage
  }

  const displayPage = currentPage || lastPage.current
  const page = displayPage ? FLYING_CARPET_PAGES[displayPage] : null

  const info = page?.getInfo ? page.getInfo() : { label: "Welcome" }

  return (
    <Drawer.Root open={isOpen} onOpenChange={(isOpen) => !isOpen && flyingCarpetStore.close()} swipeDirection="right">
      <Drawer.Portal>
        <Drawer.Backdrop className="[--backdrop-opacity:0.2] [--bleed:3rem] fixed inset-0 min-h-dvh bg-black opacity-[calc(var(--backdrop-opacity)*(1-var(--drawer-swipe-progress)))] transition-opacity duration-[450ms] ease-[cubic-bezier(0.32,0.72,0,1)] data-[swiping]:duration-0 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0 data-[ending-style]:duration-[calc(var(--drawer-swipe-strength)*400ms)] supports-[-webkit-touch-callout:none]:absolute" />
        <Drawer.Viewport className="fixed inset-0 flex items-end justify-center viewport md:right-0 md:left-auto">
          <Drawer.Popup
            className={cn(
              "h-[calc(100vh-var(--spacing-headerHeight))] flex flex-col w-full md:w-[400px] md:max-h-[calc(80vh+rem)] bg-white outline-none shadow-[0rem_-5px_20px] shadow-black/30 touch-auto [transform:translateY(var(--drawer-swipe-movement-y))] transition-transform duration-[450ms] ease-[cubic-bezier(0.32,0.72,0,1)] data-[swiping]:select-none",
              "data-[ending-style]:[transform:translateY(calc(100%))] data-[starting-style]:[transform:translateY(calc(100%))] data-[ending-style]:duration-[calc(var(--drawer-swipe-strength)*400ms)]",
              "md:data-[ending-style]:[transform:translateX(calc(100%))] data-[starting-style]:[transform:translateX(calc(100%))] data-[ending-style]:duration-[calc(var(--drawer-swipe-strength)*400ms)]",
            )}
          >
            <div className="pt-5 pb-5 px-shelf items-center border-b select-none flex">
              <div className="flex flex-col gap-3 flex-1 text-pretty">
                <Drawer.Title className="type-title-l font-bold">{info.label}</Drawer.Title>
              </div>
              <div className="flex">
                <Drawer.Close>
                  <RiCloseLargeLine />
                </Drawer.Close>
              </div>
            </div>
            <Drawer.Content className="w-full flex-1 overflow-y-auto overscroll-contain relative">
              {page && <page.component />}
            </Drawer.Content>
          </Drawer.Popup>
        </Drawer.Viewport>
      </Drawer.Portal>
    </Drawer.Root>
  )
})
